import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../stores/AuthStore';
import AuthLoader from './AuthLoader';
import IframeSyncHandler from '../IframeSyncHandler';

const SyncSession: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated, login } = useAuthStore();
  const [tokenProcessed, setTokenProcessed] = useState(false);

  useEffect(() => {
    console.log('[SyncSession] Component mounted', {
      pathname: window.location.pathname,
      search: window.location.search,
      isAuthenticated
    });

    // Check if token is passed via URL parameter (fallback method)
    const tokenFromUrl = searchParams.get('token');
    const refreshTokenFromUrl = searchParams.get('refreshToken');

    if (tokenFromUrl && !tokenProcessed) {
      console.log('[SyncSession] ✅ Token found in URL parameters');
      setTokenProcessed(true);

      // Store the token
      localStorage.setItem('smartai_auth_token', tokenFromUrl);
      if (refreshTokenFromUrl) {
        localStorage.setItem('refreshToken', refreshTokenFromUrl);
      }

      // Login with the token
      login({ accessToken: tokenFromUrl, refreshToken: refreshTokenFromUrl || undefined });

      console.log('[SyncSession] Token stored and login called, navigating to /agents');

      // Clean URL by removing token parameters (security)
      window.history.replaceState({}, '', '/sync-session');

      // Navigate to agents
      setTimeout(() => {
        navigate('/agents', { replace: true });
      }, 100);
    }
  }, [searchParams, tokenProcessed, navigate, login, isAuthenticated]);

  const handleAuthReady = () => {
    console.log('[SyncSession] ✅ Authentication synced successfully via iframe');
    // IframeSyncHandler will handle navigation to /agents
  };

  // Handle timeout - if no sync happens, redirect to login
  useEffect(() => {
    if (tokenProcessed) {
      console.log('[SyncSession] Token already processed via URL, skipping timeout');
      return;
    }

    console.log('[SyncSession] Setting up 10s timeout fallback');
    const timeout = setTimeout(() => {
      if (!tokenProcessed && !isAuthenticated) {
        console.warn('[SyncSession] ⏱️ Sync timeout reached, redirecting to login...');
        navigate('/login', { replace: true });
      }
    }, 10000); // 10 second timeout

    return () => {
      console.log('[SyncSession] Clearing timeout');
      clearTimeout(timeout);
    };
  }, [navigate, tokenProcessed, isAuthenticated]);

  return (
    <>
      <AuthLoader message="Completing sign in..." />
      {/* Only load iframe if token not received via URL */}
      {!tokenProcessed && <IframeSyncHandler onAuthReady={handleAuthReady} isBlocking={false} />}
    </>
  );
};

export default SyncSession;